import { useEffect } from 'react';

import { useSetRecoilState } from 'recoil';

import {
  bugoNavBackUrlAtom,
  bugoNavBarUseAtom,
  bugoNavBarUseNavLeftAtom,
  bugoNavRightTextAtom,
  bugoNavTitleAtom,
} from '../state';

//TODO: shared로 이동 혹은 store에도 생성
export const useTitleHook = function (
  title: string,
  rightText?: string,
  onRightTextClick?: () => void,
  use = true,
  backUrlString?: string,
  useNavLeft = true,
) {
  const setTitle = useSetRecoilState(bugoNavTitleAtom);
  const setRightText = useSetRecoilState(bugoNavRightTextAtom);
  const setUse = useSetRecoilState(bugoNavBarUseAtom);
  const setNavLeftUse = useSetRecoilState(bugoNavBarUseNavLeftAtom);
  const setBackUrl = useSetRecoilState(bugoNavBackUrlAtom);

  useEffect(() => {
    setTitle(title);
    setRightText(rightText ?? '');
    setUse(use);
    setNavLeftUse(useNavLeft);
    if (backUrlString) {
      setBackUrl(backUrlString);
    }
    return () => {
      setTitle('');
      setRightText('');
      setUse(true);
      setNavLeftUse(true);
      setBackUrl(null);
    };
  }, [
    backUrlString,
    onRightTextClick,
    rightText,
    setBackUrl,
    setNavLeftUse,
    setRightText,
    setTitle,
    setUse,
    title,
    use,
    useNavLeft,
  ]);
};
